const SaleHyfye = ()=> { return (
<section id="token" className="section_token token_sale overflow_hide">
	<div className="container">
        <div className="row">
			<div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12">
                <div className="title_dark title_border text-center">
                    <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Hyfye Token Sale</h4>
                    <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                    Be part of the next global revolution in tipping and gratitude. Early investors in Hyfye Coin (HYC) will power the world's first universal tip economy. Secure your Hyfye today — before full public launch!

                    </p>
                </div>
			</div>
        </div>
        <div className="row small_space">
        	<div className="col-lg-4">
            	<div className="token_info_table h-100">
            		<table className="table table-dark m-0 h-100">
                    	<tbody>
                            <tr className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                              <td>Starting Time :</td>
                              <td>May 01,2025</td>
                            </tr>
                            <tr className="animation" data-animation="fadeInUp" data-animation-delay="0.3s">
                              <td>Ending Time :</td>
                              <td>Aug 31,2025</td>
                            </tr>
                            <tr className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                              <td>Soft cap :</td>
                              <td>100 BNB</td>
                            </tr>
                            <tr className="animation" data-animation="fadeInUp" data-animation-delay="0.5s">
                              <td>Hard cap :</td>
                              <td>500 BNB</td>
                            </tr>
                            <tr className="animation" data-animation="fadeInUp" data-animation-delay="0.6s">
                              <td>Token :</td>
                              <td>HYC Token</td>
                            </tr>
                            <tr className="animation" data-animation="fadeInUp" data-animation-delay="0.7s">
                              <td>Exchange Rate :</td>
                              <td>1 BNB = 600M HYC</td>
                            </tr>
                            <tr className="animation" data-animation="fadeInUp" data-animation-delay="0.8s">
                              <td>Token Sale :</td>
                              <td>300 Billion HYC (30%)</td>
                            </tr>
                  		</tbody>
                    </table>
                </div>
            </div>
            <div className="col-lg-8">
            	<div className="bg_black_dark token_dt res_md_mt_30 res_xs_mt_20">
                    <div className="row align-items-center h-100">
                    	<div className="col-lg-7">
                            <div className="tk_counter_inner text-center">
                                <div className="tk_countdown_time p-0 transparent_bg box_shadow_none animation" data-animation="fadeInUp" data-animation-delay="0.2s" data-time="2019/02/06 00:00:00"></div>
                                <div className="progress animation" data-animation="fadeInUp" data-animation-delay="0.3s">
                                <div className="progress-bar progress-bar-striped gradient" role="progressbar" aria-valuenow="5" aria-valuemin="0" aria-valuemax="100" style={{width:"10%"}}> 0% </div>
                                    <span className="progress_label bg-white" style={{left: "2%"}}> <strong> 0 HYC </strong></span>
                                    <span className="progress_label bg-white" style={{left: "98%"}}> <strong> 300 Billion HYC </strong></span>
                                    <span className="progress_min_val">Sale Raised</span>
                                    <span className="progress_max_val">Soft-caps</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5">
                        	<div className="token_detail text-center res_md_mt_30 res_xs_mt_20">
                            	<ul className="list_none">
                                	<li className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">
                                    	<h4>1 HYC =  </h4>
                                    	<span>0.000000001666 BNB</span>
                                    </li>
                                    <li className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                                    	<h4>Presale Type:	</h4>
                                    	<span>Early Access Presale</span>
                                    </li>
                                   
                                </ul>
                            </div>
                        </div>
                	</div>
                </div>  
            </div>
        </div>
        <div className="divider large_divider"></div>
        <div className="row">
         
          <div className="col-lg-5 col-md-12">
              <div className="row text-center">
              <div className="col-lg-12">
                <div className="title_dark title_border text-center">
                  <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Use of Funds</h4>
                  <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                    All funds raised during the presale will be used to build, expand, and promote the Hyfye ecosystem — from platform development to global user adoption.
                  </p>
                </div>
              </div>
             </div>
             <div className="row align-items-center">
            
              <div className="col-lg-12 col-md-12">
                <ul className="list_none chart_list animation" data-animation="fadeInLeft" data-animation-delay="0.6s">
                  <li>
                        <h6>Marketing</h6>
                        <div className="progress bg-blue">
                            <div className="progress-bar" role="progressbar" style={{width: "70%"}} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100">35%</div>
                        </div>
                    </li>
                    <li>
                        <h6>Designers</h6>
                        <div className="progress bg-blue">
                            <div className="progress-bar" role="progressbar" style={{width: "10%"}} aria-valuenow="5" aria-valuemin="0" aria-valuemax="100">5%</div>
                        </div>
                    </li>
                    <li>
                        <h6>Development</h6>
                        <div className="progress bg-blue">
                            <div className="progress-bar" role="progressbar" style={{width: "30%"}} aria-valuenow="15" aria-valuemin="0" aria-valuemax="100">15%</div>
                        </div>
                    </li>
                    <li>
                        <h6>Infrastructure</h6>
                        <div className="progress bg-blue">
                            <div className="progress-bar" role="progressbar" style={{width: "10%"}} aria-valuenow="5" aria-valuemin="0" aria-valuemax="100">5%</div>
                        </div>
                    </li>
                    <li>
                        <h6>Liquidity</h6>
                        <div className="progress bg-blue">
                            <div className="progress-bar" role="progressbar" style={{width: "40%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">20%</div>
                        </div>
                    </li>
                    <li>
                        <h6>BuyBack</h6>
                        <div className="progress bg-blue">
                            <div className="progress-bar" role="progressbar" style={{width: "20%"}} aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">10%</div>
                        </div>
                    </li>
                    <li>
                        <h6>Team & Advisory</h6>
                        <div className="progress bg-blue">
                            <div className="progress-bar" role="progressbar" style={{width: "20%"}} aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">10%</div>
                        </div>
                    </li>
                </ul>
              </div>
              
            </div>
          </div>
          <div className="col-lg-2"></div>
          <div className="col-lg-5 col-md-12">
          <div className="row text-center">
          <div className="col-lg-12">
            <div className="title_dark title_border text-center">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.2s">Token Distribution</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.4s">
                  After burning 10% of total supply (100 Billion Hyfye), the remaining tokens will be fairly distributed among the community, investors, platform growth, and reserves.
              </p>
            </div>
          </div>
        </div>
        <div className="row align-items-center flex-row-reverse">
    
        <div className="col-lg-12 col-md-12">
       
            <ul className="list_none chart_list animation" data-animation="fadeInLeft" data-animation-delay="0.6s">
            	<li>
                    <h6>Public Presale	</h6>
                    <div className="progress bg-blue">
                        <div className="progress-bar" role="progressbar" style={{width: "14.46%"}} aria-valuenow="14.46" aria-valuemin="0" aria-valuemax="100">30%</div>
                    </div>
                </li>
                <li>
                    <h6>Development, Marketing, Infrastructure	</h6>
                    <div className="progress bg-blue">
                        <div className="progress-bar" role="progressbar" style={{width: "21.69%"}} aria-valuenow="21.69" aria-valuemin="0" aria-valuemax="100">10%</div>
                    </div>
                </li>
                <li>
                    <h6>Buyback Reserve	</h6>
                    <div className="progress bg-blue">
                        <div className="progress-bar" role="progressbar" style={{width: "27.71%"}} aria-valuenow="27.71" aria-valuemin="0" aria-valuemax="100">20%</div>
                    </div>
                </li>
                <li>
                    <h6>Liquidity Pools	</h6>
                    <div className="progress bg-blue">
                        <div className="progress-bar" role="progressbar" style={{width: "19.28%"}} aria-valuenow="19.28" aria-valuemin="0" aria-valuemax="100">30%</div>
                    </div>
                </li>
                <li>
                    <h6>Scalability Reserve	</h6>
                    <div className="progress bg-blue">
                        <div className="progress-bar" role="progressbar" style={{width: "16.86%"}} aria-valuenow="16.86" aria-valuemin="0" aria-valuemax="100">10%</div>
                    </div>
                </li>
            </ul>
          </div>
        </div>
          </div>
        </div>

        <div className="divider large_divider"></div>
      
    </div>
</section>);}

export default SaleHyfye;